import { useEffect, useState } from 'react';

/**
 * True when the visitor asked for less motion — via the OS setting or via our
 * own accessibility toolbar, which toggles `stop-animations` on <html>.
 *
 * Both sources matter: the CSS in fonts.js already honours the media query, but
 * anything animated in JS (a 3D scene, a scroll) has to ask.
 */
const useReducedMotion = () => {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const read = () =>
      setReduced(mq.matches || document.documentElement.classList.contains('stop-animations'));

    read();
    mq.addEventListener('change', read);
    const observer = new MutationObserver(read);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    return () => {
      mq.removeEventListener('change', read);
      observer.disconnect();
    };
  }, []);

  return reduced;
};

export default useReducedMotion;
